import Vue from "vue";
import { BusEvent } from '../../main.js'
import { newRoutes } from "../../main"

const state = {
    // نگارش نرم افزار
    VersionApp: '1.0.33',
    VersionAppLocal: '1.5.1',
    // کد سیستم حسابداری
    NSystemID: 1,

    // تنظیمات نرم افزار
    SettingWebApp: {
        // شناسه سمت سرور
        ID: 1,
        // مدت زمان مسدود شدن حساب کاربری - به دقیقه
        BlockIPTime: 5,
        // مدت زمان عدم فعالیت کاربر در میزکار - به دقیقه
        LogOutDashboardTime: 15,
        // تعداد مجاز تلاش ناموفق جهت ورود
        TryLoginCount: 3,
        // مدت زمان نمایش پیام پایان مهلت استفاده از میزکار - به ثانیه
        TimeShowLogOutDialogue: 30,
        // حجم مجاز جدول نشان ها
        CountAllowedLog: 1000,
        // مسیر ذخیره سازی سرریز جدول نشان ها
        PathSaveLogFile: 'E:\\',
    },
    // طول خلاصه سازی
    LenSubString: 25,

    // مسیر تصاویر پروژه
    ImageUrl: '/src/assets/images/',

    // لیست انواع سند/حساب
    TbBaseDocTypeData: [
        { NCode: 1, SDesc: 'افتتاحيه' },
        { NCode: 2, SDesc: 'درآمد' },
        { NCode: 3, SDesc: 'انتقالی' },
        { NCode: 4, SDesc: 'هزينه' },
        { NCode: 5, SDesc: 'انبار' },
        { NCode: 6, SDesc: 'تهاتر' },
        { NCode: 7, SDesc: 'عمومي' },
        { NCode: 8, SDesc: 'تنخواه' },
        { NCode: 9, SDesc: 'بستن حسابهای موقت' },
        { NCode: 10, SDesc: 'اختتاميه' },
    ],

    // لیست انواع اسنادی که امکان ذخیره ندارند
    ListDocNotBeSaved: [
        { NDocType: 1, SDocType: 'افتتاحیه' },
        { NDocType: 9, SDocType: 'بستن حساب‌های موقت' },
        { NDocType: 10, SDocType: 'اختتامیه' },
    ],

    // لیست انواع سرفصل حساب
    NAccTypeData: [
        { NCode: 0, SDesc: 'عادی' },
        { NCode: 1, SDesc: 'درآمد' },
        { NCode: 2, SDesc: 'هزینه' },
        { NCode: 3, SDesc: 'مازاد/کسر' },
        { NCode: 4, SDesc: 'افتتاحیه' },
        { NCode: 5, SDesc: 'اختتامیه' }
    ],

    // آخرین کد نوع سند انتخاب شده
    LastNDocTypeCode: 7,
    // آخرین کد سازمان انتخاب شده
    LastNOrgCode: 1,
    // نمایش سوابق فعالیت کاربران برای کاربر خاص
    // اگر کد ملی کاربر خالی باشد فاقد فیلتر
    OnlyShowActivityListForUserID: '',

    // لیست تب های ایجاد شده
    TabList: [{
        TabID: 1,
        TabContent: 'Dashboard', // Dashboard داشبورد  ListDocInfo لیست اسناد  AccDoc سند
        TabContentTitle: 'میزکار کاربر',
        NId: 0,
        NDocNu: 0,
        CheckChangeData: false,
        LocalData: false,
        TabAccDocData: {}
    }],

    // لیست کاربران
    ListTbUsersInfo: [{
        NUserCode: 0,
        SUserName: '',
        SDate: '',
        NPerNationalId: '',
        SImageName: '',
        SMobileNo: '',
        NOrgCode: 0,
        SOrgName: ''
    }],

    // لیست اسناد
    ListTbDocInfo: [{
        NId: 0,                    // شناسه سند
        NYear: 0,                  // سال
        NDocNu: 0,                 // شماره سند
        SDocDate: '',              // تاریخ سند
        SDocDesc: '',              // شرح سند
        BStatus: 0,                // وضعیت سند
        NUserCode: 0,              // کد کاربر
        SDate: '',                 //
        DTime: '',                 //
        SName: '',                 //
        SCheckNu: '',              //
        NCheckQuantity: 0,         //
        SDesc: '',                 //
        SDescCredit: '',           //
        NDocType: 0,               //
        NTmpDocNu: 0,              //
        NEditUserCode: 0,          //
        SEditDate: '',             //
        DEditTime: '',             //
        NOrgCode: 0                //
    }],

    // لیست کل رکوردهای کل اسناد
    // کاربرد در فرم اسناد ، تب لیست حساب ها
    TbDocInfoAllRecord: [{
        NYear: 0,              // سال
        NDocNu: 0,             // شماره سند
        NAccCode: 0,           // کد حساب
        SAccDesc: '',          // شرح حساب
        NDebit: 0,             // بدهکار
        NCredit: 0,            // بستانکار
        NPerID: 0,             // طرف حساب
        NPerName: '',          // نام طرف حساب
        NPerLastName: '',      // نام خانوادگی طرف حساب
        NPerType: 0,           // نوع طرف حساب
        NUsePlace: 0,          // مرکز هزینه
        SDesc: '',             // عنوان مرکز هزینه
        SDate: '',             // تاریخ
    }],

    // لیست حساب ها
    TbBaseAccData: [{
        NCode: "11101",
        NAccType: 4,
        SDesc: "حساب افتتاحيه",
        GA: "حساب افتتاحيه",
        CA1: "",
        CA2: ""
    },],

    // لیست کل حساب ها جهت فرم مدیریت کدینگ
    AllTbBaseAccData: [{
        NYear: 1400,
        NCode: 0,
        SDesc: '',
        NAccType: 7,
        NBudget: 0,
        NDebitSum: 0,
        NCreditSum: 0,
        NUserCode: 0,
        SDate: '',
        DTime: '',
        NPerID: 0,
        NRemain1: 0,
        NRemain2: 0,
        NRemain3: 0,
        NRemain4: 0,
        NRemain5: 0,
        NRemain6: 0,
        NRemain7: 0,
        NRemain8: 0,
        NRemain9: 0,
        NRemain10: 0,
        NRemain11: 0,
        NRemain12: 0,
        NBudgetCode: '',
        NCreditType: 0,
        NUseType: 0,
        NUseState: 0
    }],

    // لیست طرف حساب ها - اشخاص
    TbPersonData: [{
        NPerID: 326, // کد شخص
        SPerNationalId: 1, // شماره ملی
        NPerTaxNu: 0, // کد اقتصادی
        NPerNationalType: 0, // نوع شماره ملی
        NPerType: 4, // نوع شخص
        NPerTaxType: 0, // نوع مودی
        NPerName: "ماموريت", // نام شخص
        NPerLastName: "کالبدی و شهرسازي", // نام خانوادگی
        NPerProvinceCode: 0, // کد استان
        NPerCityCode: 0, // کد شهر
        NPerAddress: "", // آدرس
        NPerTelCode: 0, // کد تلفن
        NPerTel: 0, // تلفن
        NPerPostcalCode: 0, // کد پستی
        NPerKalaType: 0, // نوع کالا/خدمات
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        SJob: "", // شغل شخص
        SShopName: "", // نام فروشگاه
        SMobileNu: "", // تلفن همراه
        SFaxNu: "", // شماره فکس
        SAccNu: "", // شماره حساب
        SAccCardNu: "", // شماره کارت
        SAccIRNu: "", // شماره شبا
        NAccBank: 0, // نام بانک
        NPerFatherName: "", // نام پدر
        NYear: 0, // سال
        NGroup: 0, // کد گروه
        NPerIDPay: 0, // شماره شناسایی حقوق
        RowIndex: 0 // شماره ردیف
    }],

    // لیست طبقه بندی عملیاتی
    // اطلاعات طبقه بندی عملیاتی در جدول TbPerson ذخیره می شود
    ListTabagheBandiAmaliyati: [{
        NUserCode: 1, // کد کاربر مدیر
        NPerID: 0, // کد یکتا سطر
        SPerNationalId: 0, //  کد طبقه بندی علمیاتی
        NPerTaxNu: '', // خالی
        NPerNationalType: 1, // 1
        NPerType: 4, // کد نوع : 4 ماموریت - 5 برنامه - 6 طرح - 7 خدمت - 8 پروژه
        NPerTaxType: 5, // 5
        NPerName: 'ماموریت', // نام نوع : ماموریت - برنامه - طرح - خدمت - پروژه
        NPerLastName: '', // عنوان طبقه بندی عملیاتی
        NPerProvinceCode: 10, // کد استان
        NPerCityCode: 1001000, // کد شهر
        NPerAddress: '', // خالی
        NPerTelCode: '', // خالی
        NPerTel: '', // خالی
        NPerPostcalCode: '', // خالی
        NPerKalaType: 12, // 12
        SDate: '', // تاریخ ثبت
        DTime: '', // ساعت ثبت
        SJob: '', // خالی
        SShopName: '', // خالی
        SMobileNu: '', // خالی
        SFaxNu: '', // خالی
        SAccNu: '', // خالی
        SAccCardNu: '', // خالی
        SAccIRNu: '', // خالی
        NAccBank: 0, // 0
        NPerFatherName: '', // خالی
        NYear: '', // سال
        NGroup: 0, // 0
        NPerIDPay: 0, // 0
    }],

    // لیست مراکز هزینه
    TbBaseUsePlaceData: [{
        NCode: 854,
        SDesc: "فرهنگي و اجتماعي",
        SDate: "1400/06/28"
    }],

    // لیست شرح سندها
    TbBaseDocDescsData: [{
        NCode: 1,
        SDesc: "پرداختي در وجه بانك ملي بابت پرداخت ليست پيوست",
        SDate: "1399/02/30"
    }],

    // لیست کلیه سطوح دسترسی موجود در نرم افزار
    TbObjects: [{
        NObjectId: 1,  // شناسه منحصر به فرد آبجکت
        SObjectName: 1,  // اضافی و باید از بانک حذف شود
        SObjectName_Fa: 'اطلاعات پايه',  // نام آبجکت
        NObjectParentId: 1,  // کد والد آبجکت
        NSystemId: 1,   // کد سیستم آبجکت : حسابداری 1
        NObjectType: 1, // نوع آبجکت : منوها 1 سایر 2
        WebIconName: '', // نام آیکون وب
        WebFormName: '' // نام فرم وب
    }],

    // لیست دسترسی های کاربر لاگین کرده
    TbUserObjects: [{
        // NUserObjectId, NUserId, NObjectId, NGroupUserId
        NUserCode: 1,
        NObjectId: 2,
        BIsAddNew: true,
        BIsDelete: true,
        BIsReport: true
    }],

    // لیست شرح حساب ها - شرح دریف ها
    TbBaseAccDescData: [{
        NCode: 1,
        SDesc: "طي فيش شماره",
        SDate: "1396/07/18"
    }],

    // لیست قراردادها
    TbBaseAgreementData: [{
        NAgrID: 0,
        SAgrNu: "",
        SAgrDate: "",
        SAgrType: "",
        SAgrSubject: "",
        NAmount: "",
        SStartDate: "",
        SEndDate: "",
        NUpAmountState: "",
        SUpLetterNu: "",
        SUpLetterDate: "",
        NUpTimeState: "",
        SUpTimeNu: "",
        SUpTimeDate: "",
        SUpTime: "",
        NCertainDeliver: "",
        NTempDeliver: "",
        SMaterial: "",
        SViewerName: ""
    }],

    // لیست سازمان ها
    TbBaseOrgData: [{
        NCode: 1,
        SDesc: 'شهرداری تربت حیدریه'
    }],

    // لیست نوع شخصیت در ثبت اشخاص
    NPerTypeList: [
        { NPerTypeCode: 0, NPerTypeText: 'نوع شخصیت' },
        { NPerTypeCode: 1, NPerTypeText: 'حقیقی' },
        { NPerTypeCode: 2, NPerTypeText: 'حقوقی' }
    ],

    // لیست نوع مودی در ثبت اشخاص
    NPerTaxTypeList: [
        { NPerTaxTypeCode: 0, NPerTaxTypeText: 'نوع مودی' },
        { NPerTaxTypeCode: 1, NPerTaxTypeText: 'مشمول ثبت نام در نظام مالیاتی' },
        { NPerTaxTypeCode: 2, NPerTaxTypeText: 'مشمولین حقیقی ماده 81' },
        { NPerTaxTypeCode: 3, NPerTaxTypeText: 'اشخاصی که ملزم به ثبت نام' },
        { NPerTaxTypeCode: 4, NPerTaxTypeText: 'مصرف کننده نهایی' }
    ],

    // لیست نوع کالا/خدمات در ثبت اشخاص
    NPerKalaTypeList: [
        { NPerKalaTypeCode: 0, NPerKalaTypeText: 'نوع کالا/خدمات' },
        { NPerKalaTypeCode: 1, NPerKalaTypeText: 'دارو' },
        { NPerKalaTypeCode: 2, NPerKalaTypeText: 'دخانیات' },
        { NPerKalaTypeCode: 3, NPerKalaTypeText: 'موبایل' },
        { NPerKalaTypeCode: 4, NPerKalaTypeText: 'لوازم خانگی برقی' },
        { NPerKalaTypeCode: 5, NPerKalaTypeText: 'قطعات مصرفی و یدکی' },
        { NPerKalaTypeCode: 6, NPerKalaTypeText: 'فرآورده ها و مشتقات' },
        { NPerKalaTypeCode: 7, NPerKalaTypeText: 'طلا اعم از شمش' },
        { NPerKalaTypeCode: 8, NPerKalaTypeText: 'منسوجات و پوشاک' },
    ],

    // لیست گروه در ثبت اشخاص
    NGroupList: [
        { NGroupCode: 0, NGroupText: 'گروه' },
        { NGroupCode: 1, NGroupText: 'کارکنان' },
        { NGroupCode: 2, NGroupText: 'شرکت' },
        { NGroupCode: 3, NGroupText: 'شخص' },
        { NGroupCode: 4, NGroupText: 'کارکنان شرکتی' },
        { NGroupCode: 5, NGroupText: 'تملک' },
    ],

    // لیست تابعیت در ثبت اشخاص
    NPerNationalTypeList: [
        { NPerNationalTypeCode: 0, NPerNationalTypeText: 'تابعیت' },
        { NPerNationalTypeCode: 1, NPerNationalTypeText: 'ایرانی' },
        { NPerNationalTypeCode: 2, NPerNationalTypeText: 'خارجی' },
    ],

    // لیست استان ها در ثبت اشخاص
    NPerProvinceList: [
        { NPerProvinceCode: 0, NPerProvinceText: 'استان' },
        { NPerProvinceCode: 19, NPerProvinceText: 'خراسان رضوی' },
    ],

    // لیست شهرها در ثبت اشخاص
    NPerCityList: [
        { NPerProvinceCode: 0, NPerCityCode: 0, NPerCityText: 'شهر' },
        { NPerProvinceCode: 19, NPerCityCode: 1901000, NPerCityText: 'مشهد' },

    ],

    // لیست نوع مصرف منبع در سرفصل حساب ها
    NUseTypeList: [
        { NUseTypeCode: 0, NUseTypeText: 'نوع مصرف منبع' }
    ],

    // لیست نوع اعتبار در سرفصل حساب ها
    NCreditTypeList: [
        { NCreditTypeCode: 0, NCreditTypeText: 'نوع اعتبار' }
    ],

    // لیست بانک ها
    TbBaseBankData: [{
        NCode: 0,
        SDesc: 'نام بانک'
    }],

    // گزارش ترازنامه
    SelectBalance: {
        // سطرهای گزارش ترازنامه
        SpSelectBalanceRows: [{
            NAccCode: 0,         // کد حساب
            SAccCode: '',        // عنوان حساب
            NDebit: 0,           // بدهکار اول دوره
            NCredit: 0,          // بستانکار اول دوره
            NDebit1: 0,          // بدهکار طی دوره
            NCredit1: 0,         // بستانکار طی دوره
            NDebit2: 0,          // بدهکار پایان دوره
            NCredit2: 0,         // بستانکار پایان دوره
            NDebitState: 0,      // وضعیت بدهکار
            NCreditState: 0      // وضعیت بستانکار
        }],
        // جمع کل انتهای گزارش ترازنامه
        SpSelectBalanceSum: {
            NAccCode: 0,         // شماره ردیف - تعداد سطرهای گزارش
            SDesc: '',           // عنوان سطر : جمع کل
            NDebit: 0,           // بدهکار اول دوره
            NCredit: 0,          // بستانکار اول دوره
            NDebit1: 0,          // بدهکار طی دوره
            NCredit1: 0,         // بستانکار طی دوره
            NDebit2: 0,          // بدهکار پایان دوره
            NCredit2: 0,         // بستانکار پایان دوره
            NDebitState: 0,      // وضعیت بدهکار
            NCreditState: 0,     // وضعیت بستانکار
        },
        // مقادیر راهنمای کاربر
        SpSelectBalanceGuide: {
            MinNDocNu: 0,        // اولین شماره سند
            MaxNDocNu: 0,        // آخرین شماره سند
            MinSDate: '',        // اولین تاریخ
            MaxSDate: '',        // آخرین تاریخ
        }
    },



    // تاریخ شمسی جاری
    PersianDateValue: {
        PersianYear: '1400',
        PersianDate: '1400/02/01',
        PersianDateTime: '1400/02/01 07:00'
    },

    // لیست سال های دارای اطلاعات
    ListYearData: [1401],

    // سال فعال
    YearActive: 1400,

    // فیلد کنترل اضافه شدن شنونده کلید میانبرها
    canAddListenerHotKey: true,

    // لیست آی پی های مسدود شده
    ListBlockIP: [
        { ID: 0, UserIP: '', BlockDate: '', CountError: 0, BlockIPTime: 0, ActiveStatus: 0 }
    ]
}

const getters = {
    // دریافت لیست گزارش ترازنامه
    getSelectBalance(state) {
        return state.SelectBalance;
    },
    // دریافت سال فعال
    getYearActive(state) {
        return state.YearActive;
    },
    // دریافت لیست سال های دارای اطلاعات
    getListYearData(state) {
        return state.ListYearData;
    },
    // دریافت آخرین سال فعال کاربر
    getLastYearData(state) {
        if (state.ListYearData.length != 0) {
            let yearID = 0;
            state.ListYearData.forEach(function (year) {
                if (year > yearID) {
                    yearID = year;
                }
            });
            return yearID;
        } else {
            // اطلاعات سال فعال کاربر خالی است
            // برگشت سال جاری
            return this.getPersianDateValue.PersianYear;
        }
    },
    // دریافت لیست تب ها
    getTabList(state) {
        return state.TabList;
    },
    // دریافت کد سیستم حسابداری
    getNSystemID(state) {
        return state.NSystemID;
    },
    // دریافت شماره نگارش نرم افزار
    getVersionApp(state) {
        return state.VersionApp;
    },
    // دریافت تنظیمات نرم افزار
    getSettingWebApp(state) {
        return state.SettingWebApp;
    },
    // دریافت لیست انواع سند
    getTbBaseDocTypeData(state) {
        return state.TbBaseDocTypeData;
    },
    // دریافت لیست انواع سرفصل حساب
    getNAccTypeData(state) {
        return state.NAccTypeData;
    },
    // دریافت نام نوع سرفصل حساب از روی کد نوع
    getNAccTypeName(state) {
        return (NCode) => {
            return state.NAccTypeData.filter(function (t) {
                return t.NCode == NCode
            });
        }
    },
    // دریافت آدرس تصاویر
    getImageUrl(state) {
        return state.ImageUrl;
    },
    // دریافت لیست کاربران
    getListTbUsersInfo(state) {
        return state.ListTbUsersInfo;
    },
    // دریافت لیست تمام رکوردهای تمام سندها
    getTbDocInfoAllRecord(state) {
        return state.TbDocInfoAllRecord;
    },
    // دریافت لیست اسناد
    getListTbDocInfo(state) {
        return state.ListTbDocInfo;
    },
    // دریافت اطلاعات سند با کد سند
    getTbDocInfoByNDocNu(state) {
        return async (NDocNu) => {
            let doclist = await state.ListTbDocInfo;
            return doclist.filter(function (t) {
                return t.NDocNu == NDocNu
            });
        }
    },
    // دریافت اطلاعات سند با شناسه سند
    getTbDocInfoByNId(state) {
        return async (NId) => {
            let doclist = await state.ListTbDocInfo;
            return doclist.filter(function (t) {
                return t.NId == NId
            });
        }
    },
    // دریافت تاریخ آخرین سند
    getDateLastDoc(state) {
        return async () => {
            let dateLastDoc = 0;
            // اجرای یک حلقه فور و استخراج بزرگترین شماره سند
            let list = await state.ListTbDocInfo;
            await list.forEach(function (tab) {
                if (parseInt(tab.SDocDate.toString().replace(/\//g, '')) > dateLastDoc) {
                    dateLastDoc = parseInt(tab.SDocDate.toString().replace(/\//g, ''));
                }
            });
            return dateLastDoc;
        }
    },
    // دریافت بزرگترین شماره و شناسه سند
    async getLargestNDocNuNId(state) {
        let largestNDocNu = 0;
        let list = await state.ListTbDocInfo;
        // اجرای یک حلقه فور و استخراج بزرگترین شماره سند
        list.forEach(function (tab) {
            if (tab.NDocNu > largestNDocNu) {
                largestNDocNu = tab.NDocNu;
            }
        });
        return largestNDocNu + 1;
    },
    // دریافت لیست سازمان ها
    getTbBaseOrgData(state) {
        return state.TbBaseOrgData;
    },
    // دریافت لیست نوع شخصیت
    getNPerType(state) {
        return state.NPerTypeList;
    },
    // دریافت لیست نوع مودی
    getNPerTaxType(state) {
        return state.NPerTaxTypeList;
    },
    // دریافت لیست نوع کالا/خدمات
    getNPerKalaType(state) {
        return state.NPerKalaTypeList;
    },
    // دریافت لیست گروه
    getNGroup(state) {
        return state.NGroupList;
    },
    // دریافت لیست تابعیت
    getNPerNationalType(state) {
        return state.NPerNationalTypeList;
    },
    // دریافت لیست استان ها
    getNPerProvince(state) {
        return state.NPerProvinceList;
    },
    // دریافت لیست شهرها
    getNPerCity(state) {
        return (ProvinceCode) => {
            return state.NPerCityList.filter(function (t) {
                return t.NPerProvinceCode == ProvinceCode
            });
        }
    },
    // دریافت لیست مصرف منبع در سرفصل حساب ها
    getNUseType(state) {
        return state.NUseTypeList;
    },
    // دریافت لیست نوع اعتبار در سرفصل حساب ها
    getNCreditType(state) {
        return state.NCreditTypeList;
    },
    // دریافت لیست بانک ها
    getTbBaseBankData(state) {
        return state.TbBaseBankData;
    },
    // دریافت تاریخ شمسی جاری
    getPersianDateValue(state) {
        return state.PersianDateValue;
    },
    // دریافت لیست آی پی های مسدود شده
    getListBlockIP(state) {
        return state.ListBlockIP;
    },
    // دریافت لیست حساب ها
    // فقط آخرین سطح به همراه نام سطوح والد
    getTbBaseAccData(state) {
        return state.TbBaseAccData;
    },
    // دریافت لیست کل حساب ها جهت مدیریت فرم کدینگ
    getAllTbBaseAccData(state) {
        return state.AllTbBaseAccData;
    },
    // دریافت لیست حساب های درآمد و هزینه جهت مدیریت فرم بودجه
    getAllTbBaseAccBudgetData(state) {
        return state.AllTbBaseAccData.filter(function (item) {
            // هزینه:2 - درآمد:1
            return item.NAccType == 1 || item.NAccType == 2
        });
    },
    // دریافت جمع کل هزینه ها یا درآمدها
    getSumTbBaseAccBudget(state) {
        // NAccType = هزینه:2 - درآمد:1
        return (NAccType) => {
            let tempData = state.AllTbBaseAccData.filter(function (item) {
                return item.NAccType == NAccType && item.NCode.length == 3
            });
            let sumValue = 0;
            tempData.forEach(function (item) {
                sumValue += item.NBudget;
            })
            return sumValue;
        }
    },
    // دریافت لیست مرکز هزینه ها
    getTbBaseUsePlaceData(state) {
        return state.TbBaseUsePlaceData;
    },
    // دریافت وضعیت فیلتر سوابق فعالیت کاربران برای کاربر خواص
    getOnlyShowActivityListForUserID(state) {
        return state.OnlyShowActivityListForUserID;
    },
    // دریافت لیست قراردادها
    getTbBaseAgreementData(state) {
        return state.TbBaseAgreementData;
    },
    // دریافت لیست شرح سندها
    getTbBaseDocDescsData(state) {
        return state.TbBaseDocDescsData;
    },
    // دریافت لیست کلیه سطوح دسترسی موجود در نرم افزار
    getTbObjects(state) {
        return state.TbObjects;
    },
    // دریافت لیست سطوح دسترسی کاربر لاگین کرده
    getTbUserObjects(state) {
        return state.TbUserObjects;
    },
    // دریافت لیست شرح حساب ها - شرح ردیف ها
    getTbBaseAccDescData(state) {
        return state.TbBaseAccDescData;
    },
    // دریافت شرح حساب - شرح ردیف از روی کد حساب
    getTbBaseAccDescDataName(state) {
        return (NCode) => {
            let index = state.TbBaseAccDescData.findIndex(itme => itme.NCode == NCode)
            // console.log('NCode : ' + NCode + ' | index : ' + index);
            if (index != -1) {
                return state.TbBaseAccDescData[index].SDesc;
            } else {
                return '';
            }
        }
    },
    // دریافت نام حساب از روی کد تمام حساب ها
    getAllTbBaseAccDataName(state) {
        return (NCode) => {
            let index = state.AllTbBaseAccData.findIndex(itme => itme.NCode == NCode)
            if (index != -1) {
                let SDesc = state.AllTbBaseAccData[index].SDesc;
                SDesc = (SDesc.length > state.LenSubString ? SDesc.substring(0, state.LenSubString) + ' ...' : SDesc);
                return { SDesc: SDesc, NAccType: state.AllTbBaseAccData[index].NAccType, NPerID: state.AllTbBaseAccData[index].NPerID };
            } else {
                return { SDesc: '', NAccType: 0, NPerID: 0 };
            }
        }
    },
    // دریافت نام حساب از روی کد حساب
    getTbBaseAccDataName(state) {
        return (NCode) => {
            let index = state.TbBaseAccData.findIndex(itme => itme.NCode == NCode)
            if (index != -1) {
                let strGA = (state.TbBaseAccData[index].GA != '' && state.TbBaseAccData[index].GA != state.TbBaseAccData[index].SDesc ? state.TbBaseAccData[index].GA +
                    (state.TbBaseAccData[index].CA1 != '' ? "/" + state.TbBaseAccData[index].CA1 +
                        (state.TbBaseAccData[index].CA2 != '' ? "/" + state.TbBaseAccData[index].CA2 : '') : '') : '');
                if (strGA.length > state.LenSubString) {
                    strGA = strGA.substring(0, state.LenSubString) + ' ...';
                }
                let SDesc = state.TbBaseAccData[index].SDesc;
                SDesc = (SDesc.length > state.LenSubString ? SDesc.substring(0, state.LenSubString) + ' ...' : SDesc);
                return { SDesc: SDesc, NAccType: state.TbBaseAccData[index].NAccType, NPerID: state.TbBaseAccData[index].NPerID };
            } else {
                return { SDesc: '', NAccType: 0, NPerID: 0 };
            }
        }
    },
    // دریافت نام حساب و نوع حساب از روی کد حساب
    getTbBaseAccDataNameAndType(state) {
        return (NCode) => {
            let index = state.TbBaseAccData.findIndex(itme => itme.NCode == NCode)
            if (index != -1) {
                return {
                    NCode: state.TbBaseAccData[index].NCode,
                    SDesc: state.TbBaseAccData[index].SDesc,
                    NAccType: state.TbBaseAccData[index].NAccType,
                    NPerID: state.TbBaseAccData[index].NPerID
                }
            } else {
                return {
                    NCode: 0,
                    SDesc: '',
                    NAccType: 0,
                    NPerID: 0
                };
            }
        }
    },
    // دریافت نام طرف حساب و نوع طرف حساب از روی کد طرف حساب
    getTbPersonDataNameAndType(state) {
        return (NPerID) => {
            if (NPerID > 0) {
                let index = state.TbPersonData.findIndex(itme => itme.NPerID == NPerID)
                if (index != -1) {
                    return {
                        NPerID: state.TbPersonData[index].NPerID,
                        NPerName: state.TbPersonData[index].NPerName,
                        NPerLastName: state.TbPersonData[index].NPerLastName,
                        NPerType: state.TbPersonData[index].NPerType
                    }
                } else {
                    return {
                        NPerID: 0,
                        NPerName: '',
                        NPerLastName: '',
                        NPerType: 0
                    };
                }
            } else {
                return {
                    NPerID: 0,
                    NPerName: '',
                    NPerLastName: '',
                    NPerType: 0
                };
            }
        }
    },
    // دریافت نام مرکز هزینه از روی کد مرکز هزینه
    getTbBaseUsePlaceName(state) {
        return (NCode) => {
            if (NCode > 0) {
                let index = state.TbBaseUsePlaceData.findIndex(itme => itme.NCode == NCode)
                if (index != -1) {
                    return {
                        NCode: state.TbBaseUsePlaceData[index].NCode,
                        SDesc: state.TbBaseUsePlaceData[index].SDesc,
                        SDate: state.TbBaseUsePlaceData[index].SDate
                    }
                } else {
                    return {
                        NCode: 0,
                        SDesc: '',
                        SDate: ''
                    };
                }
            } else {
                return {
                    NCode: 0,
                    SDesc: '',
                    SDate: ''
                };
            }
        }
    },
    // دریافت نام قرارداد از روی کد قرارداد
    getTbBaseAgreementName(state) {
        return (NAgrID) => {
            if (NAgrID > 0) {
                let index = state.TbBaseAgreementData.findIndex(itme => itme.NAgrID == NAgrID)
                if (index != -1) {
                    return {
                        NAgrID: state.TbBaseAgreementData[index].NAgrID,
                        SAgrSubject: state.TbBaseAgreementData[index].SAgrSubject,
                        SViewerName: state.TbBaseAgreementData[index].SViewerName,
                        NAmount: state.TbBaseAgreementData[index].NAmount,
                        SDate: state.TbBaseAgreementData[index].SDate
                    }
                } else {
                    return {
                        NAgrID: 0,
                        SAgrSubject: '',
                        SViewerName: '',
                        NAmount: 0,
                        SDate: ''
                    };
                }
            } else {
                return {
                    NAgrID: 0,
                    SAgrSubject: '',
                    SViewerName: '',
                    NAmount: 0,
                    SDate: ''
                };
            }
        }
    },
    // دریافت لیست طرف حساب ها
    getTbPersonData(state) {
        return (NAccType) => {
            if (NAccType == 0)
                // فقط اشخاص حقیقی و حقوقی را بازگشت بده
                return state.TbPersonData.filter(function (t) {
                    return t.NPerType == 1 || t.NPerType == 2
                });
            else if (NAccType == 1)
                return null;
            else if (NAccType == 2)
                return state.TbPersonData.filter(function (t) {
                    return t.NPerType == 7 || t.NPerType == 8
                });
            else if (NAccType == 3)
                // طبقه بندی عملیاتی - لیست پروژه ها را بازگشت بده
                return state.TbPersonData.filter(function (t) {
                    return t.NPerType == 4 || t.NPerType == 5 || t.NPerType == 6 || t.NPerType == 8
                });
            else if (NAccType == 4)
                // طبقه بندی عملیاتی - لیست خدمت ها را بازگشت بده
                return state.TbPersonData.filter(function (t) {
                    return t.NPerType == 4 || t.NPerType == 5 || t.NPerType == 7
                });
            else
                return state.TbPersonData;
        }
    },
    // دریافت لیست طبقه بندی عملیاتی
    getListTabagheBandiAmaliyati(state) {
        return (TabagheBandiType) => {
            if (TabagheBandiType == 1)
                // طبقه بندی عملیاتی - لیست پروژه ها را بازگشت بده
                return state.ListTabagheBandiAmaliyati.filter(function (t) {
                    return t.NPerType == 4 || t.NPerType == 5 || t.NPerType == 6 || t.NPerType == 8
                });
            else if (TabagheBandiType == 2)
                // طبقه بندی عملیاتی - لیست خدمت ها را بازگشت بده
                return state.ListTabagheBandiAmaliyati.filter(function (t) {
                    return t.NPerType == 4 || t.NPerType == 5 || t.NPerType == 7
                });
        }
    },
    // دریافت طول خلاصه نویسی
    getLenSubString(state) {
        return state.LenSubString;
    },
    // دریافت کنترل کننده شنونده کلید میانبرها
    getcanAddListenerHotKey(state) {
        return state.canAddListenerHotKey;
    },
    // دریافت کد نوع سند جهت ایجاد سند جدید
    getNDocTypeCodeForNewDoc(state) {
        if (state.TbBaseDocTypeData.length != 0) {
            // آیا آخرین انتخاب در لیست موجود است ؟
            let index = state.TbBaseDocTypeData.findIndex(itme => itme.NCode == state.LastNDocTypeCode)
            if (index != -1) {
                // آخرین انتخاب در لیست موجود بود
                return state.LastNDocTypeCode;
            } else {
                // آخرین انتخاب در لیست موجود نبود
                state.LastNDocTypeCode = state.TbBaseDocTypeData[0].NCode;
                return state.LastNDocTypeCode;
            }
        } else {
            return 0;
        }
    },
    // دریافت کد سازمان جهت ایجاد سند جدید
    getNOrgCodeCodeForNewDoc(state) {
        if (state.TbBaseOrgData.length != 0) {
            // آیا آخرین انتخاب در لیست موجود است ؟
            let index = state.TbBaseOrgData.findIndex(itme => itme.NCode == state.LastNOrgCode)
            if (index != -1) {
                // آخرین انتخاب در لیست موجود بود
                return state.LastNOrgCode;
            } else {
                // آخرین انتخاب در لیست موجود نبود
                state.LastNOrgCode = state.TbBaseOrgData[0].NCode;
                return state.LastNOrgCode;
            }
        } else {
            return 0;
        }
    },
    // دریافت نام سازمان از روی کد سازمان
    getOrgNameFromOrgCode(state){
        return (NOrgCode) => {
            if (state.TbBaseOrgData.length != 0) {
                // جستجو در لیست سازمان ها بر اساس کد سازمان
                let index = state.TbBaseOrgData.findIndex(itme => itme.NCode == NOrgCode)
                if (index != -1) {
                    // برگشت نام سازمان پیدا شده
                    return state.TbBaseOrgData[index].SDesc;
                } else {
                    // با کد ارسالی سازمانی مشاهده نشد
                    return '';
                }
            } else {
                // لیست سازمان ها خالی است
                return '';
            }
        }
    }
}

const mutations = {
    // ثبت لیست گزارش ترازنامه
    setSelectBalance(state, selectbalance) {
        state.SelectBalance = selectbalance;
    },
    // ثبت آخرین انتخاب نوع سند جهت استفاده در ایجاد سند جدید
    setLastNDocTypeCode(state, ndoctype) {
        state.LastNDocTypeCode = ndoctype;
    },
    // ثبت آخرین انتخاب سازمان جهت استفاده در ایجاد سند جدید
    setLastNOrgCode(state, norgcode) {
        state.LastNOrgCode = norgcode;
    },
    // دریافت وضعیت فیلتر سوابق فعالیت کاربران برای کاربر خواص
    setOnlyShowActivityListForUserID(state, UserID) {
        // ثبت کد ملی کاربر مورد نظر
        state.OnlyShowActivityListForUserID = UserID
    },
    // ثبت سال فعال
    setYearActive(state, yearactive) {
        state.YearActive = yearactive;
    },
    // ثبت لیست سال های دارای اطلاعات
    setListYearData(state, listyeardata) {
        state.ListYearData = listyeardata;
    },
    // ثبت تب جدید
    addTabList(state, tabData) {
        let TabID = 1;
        if (state.TabList.length > 0) {
            TabID = state.TabList[state.TabList.length - 1].TabID + 1;
        };
        let index = -1;

        // اگر تب تقاضا شده سند جدید بود
        if (tabData.tabContent === 'AccDoc') {
            index = (tabData.NDocNu != 0 ?
                state.TabList.findIndex(
                    itme => itme.TabContent === 'AccDoc' &&
                        itme.NDocNu == tabData.NDocNu) :
                -1);
            if (index != -1) {
                // سند مورد نظر باز است لذا انتقال فوکوس به تب موجود
                tabData.tabID = state.TabList[index].TabID;
            } else {
                // ایجاد تب جدید
                state.TabList.push({
                    TabID: TabID,
                    TabContent: tabData.tabContent,
                    TabContentTitle: 'سند شماره ' + tabData.NDocNu,
                    NId: tabData.NId,
                    NDocNu: tabData.NDocNu,
                    CheckChangeData: tabData.CheckChangeData,
                    LocalData: tabData.LocalData,
                    TabAccDocData: tabData.TabAccDocData
                });
                // پس دادن شماره تب به تابع والد
                tabData.tabID = TabID;
            }
        } else {
            //if (tabData.tabContent === 'ListDocInfo' || tabData.tabContent === 'Dashboard') {
            // اگر تب تقاضا شده لیست اسناد یا داشبورد یا سایر فرم ها بود
            index = state.TabList.findIndex(
                itme => itme.TabContent === tabData.tabContent.toString());
            if (index != -1) {
                // تب مورد نظر تکراری است لذا انتقال فوکوس به تب موجود
                tabData.tabID = state.TabList[index].TabID;
            } else {
                // تب مورد نظر غیر تکراری است لذا ایجاد تب جدید
                state.TabList.push({
                    TabID: TabID,
                    TabContent: tabData.tabContent,
                    TabContentTitle: tabData.tabContentTitle,
                    NId: tabData.NId,
                    NDocNu: tabData.NDocNu,
                    CheckChangeData: tabData.CheckChangeData,
                    LocalData: tabData.LocalData,
                    TabAccDocData: tabData.TabAccDocData
                });
                // پس دادن شماره تب به تابع والد
                tabData.tabID = TabID;
            }
            // اگر تب تقاضا شده ، سند بود
        }
        console.log(tabData.tabContent);
    },
    // نگهداری وضعیت تغییرات در سند
    setChangeDataInTab(state, { tabID, tabDataForChange }) {
        // ذخیره وجود تغییرات در لیست تب ها
        let index = state.TabList.findIndex(itme => itme.TabID == tabID)
        if (index != -1) {
            // شناسه سند
            state.TabList[index].NId = tabDataForChange.NId;
            // شماره سند
            state.TabList[index].NDocNu = tabDataForChange.NDocNu;
            // آیا اطلاعات محلی است
            state.TabList[index].LocalData = tabDataForChange.LocalData;
            // مخزن اطلاعات محلی
            state.TabList[index].TabAccDocData = tabDataForChange.TabAccDocData;
            // در سند تغیراتی وجود دارد و نیاز به ذخیره اطلاعات است
            state.TabList[index].CheckChangeData = tabDataForChange.CheckChangeData;
            // عنوان نمایشی سند
            state.TabList[index].TabContentTitle = 'سند شماره ' + tabDataForChange.NDocNu;
        }
    },
    // نگهداری اطلاعات لیست کاربران
    setListTbUsersInfo(state, listtbusersinfo) {
        state.ListTbUsersInfo = listtbusersinfo;
    },
    // ویرایش اطلاعات کاربر در لیست محلی کاربران
    setChangeUserProfileDataInList(state, { userData }) {
        // ذخیره وجود تغییرات در لیست کاربران
        let index = state.ListTbUsersInfo.findIndex(itme => itme.NUserCode == userData.NUserCode)
        if (index != -1) {
            // نام کاربر
            state.ListTbUsersInfo[index].SUserName = userData.SUserName;
            // کد ملی کاربر
            state.ListTbUsersInfo[index].NPerNationalId = userData.NPerNationalId;
            // تصویر کاربر
            state.ListTbUsersInfo[index].SImageName = userData.SImageName;
            // تلفن همراه
            state.ListTbUsersInfo[index].SMobileNo = userData.SMobileNo;
            // کد سازمان
            state.ListTbUsersInfo[index].NOrgCode = userData.NOrgCode;
            // نام سازمان
            state.ListTbUsersInfo[index].SOrgName = userData.SOrgName;
        }
    },
    // ثبت کاربر جدید در لیست محلی کاربران
    AddNewUserToLocalList(state, { userData }) {
        // ذخیره کاربر جدید در لیست کاربران
        // درج در ابتدایی آرایه unshift
        // درج در انتهای آرایه push
        state.ListTbUsersInfo.unshift({
            NUserCode: userData.NUserCode,
            SUserName: userData.SUserName,
            NPerNationalId: userData.NPerNationalId,
            // SImageName: userData.SImageName,
            SMobileNo: userData.SMobileNo,
            NOrgCode: userData.NOrgCode,
            SOrgName: userData.SOrgName,
            SDate: userData.SDate,
            NState: userData.NState  // وضعیت فعالیت : فعال
        });
    },
    // حذف کاربر از لیست محلی کاربران
    DeleteUserToLocalList(state, { NUserCode }) {
        // حذف کاربر از لیست محلی
        state.ListTbUsersInfo = state.ListTbUsersInfo.filter(function (u) {
            return u.NUserCode != NUserCode;
        })
    },
    // تغییر وضعیت فعالیت کاربر در لیست محلی کاربران
    ChangeNStateUserToLocalList(state, { NUserCode, ActiveState }) {
        let index = state.ListTbUsersInfo.findIndex(itme => itme.NUserCode == NUserCode)
        if (index != -1) {
            // تغییر وضعیت فعالیت کاربر
            state.ListTbUsersInfo[index].NState = (ActiveState == true ? 1 : 2);
            state.ListTbUsersInfo[index].StateActive = (ActiveState == true ? "فعال" : "غیرفعال");
        }
    },

    // نگهداری اطلاعات لیست اسناد
    setListTbDocInfo(state, listTbDocInfo) {
        state.ListTbDocInfo = listTbDocInfo;
    },
    // نگهداری اطلاعات لیست تمام رکوردهای تمام سندها
    setTbDocInfoAllRecord(state, listTbDocInfoAllRecord) {
        state.TbDocInfoAllRecord = listTbDocInfoAllRecord;
    },
    // ویرایش وضعیت سند به دائمی
    changeDocStatusInLocall(state, { NId }) {
        // ذخیره وجود تغییرات در لیست کاربران
        let index = state.ListTbDocInfo.findIndex(itme => itme.NId == NId)
        if (index != -1) {
            // تغییر وضعیت سند به دائمی
            state.ListTbDocInfo[index].BStatus = true;
            state.ListTbDocInfo[index].SStatus = "قطعی";
        }
    },
    // حذف مرکز هزینه از لیست محلی
    DeleteBaseUsePlaceToLocalList(state, { NCode }) {
        // حذف مرکز هزینه از لیست محلی
        state.TbBaseUsePlaceData = state.TbBaseUsePlaceData.filter(function (u) {
            return u.NCode != NCode;
        })
    },
    // نگهداری تاریخ شمسی جاری
    setPersianDateValue(state, persianDate) {
        state.PersianDateValue = persianDate;
    },
    // نگهداری لیست آی پی های مسدود شده
    setListBlockIP(state, listblockip) {
        state.ListBlockIP = listblockip;
    },
    // نگهداری لیست حساب ها
    setTbBaseAccData(state, tbBaseAcc) {
        if (tbBaseAcc.length > 0) {
            // درج شماره ردیف برای سطرها
            // شماره ردیف در صفحه بندی کاربرد دارد
            for (let i = 0; i < tbBaseAcc.length; i++) {
                tbBaseAcc[i].RowID = i + 1;
            }
        }
        state.TbBaseAccData = tbBaseAcc;
    },
    // نگهداری لیست کل حساب ها جهت فرم مدیریت کدینگ
    setAllTbBaseAccData(state, tbBaseAcc) {
        state.AllTbBaseAccData = tbBaseAcc;
    },
    // نگهداری لیست طرف حساب ها
    setTbPersonData(state, tbPerson) {
        state.TbPersonData = tbPerson;
    },
    // نگهداری لیست طبقه بندی عملیاتی
    setListTabagheBandiAmaliyati(state, TabagheBandiAmaliyati) {
        state.ListTabagheBandiAmaliyati = TabagheBandiAmaliyati;
    },
    // نگهداری لیست مراکز هزینه
    setTbBaseUsePlaceData(state, tbBaseUsePlace) {
        if (tbBaseUsePlace.length > 0) {
            // درج شماره ردیف برای سطرها
            // شماره ردیف در صفحه بندی کاربرد دارد
            for (let i = 0; i < tbBaseUsePlace.length; i++) {
                tbBaseUsePlace[i].RowID = i + 1;
            }
        }
        state.TbBaseUsePlaceData = tbBaseUsePlace;
    },
    // نگهداری لیست پروژه ها
    setTbBaseAgreementData(state, tbBaseAgr) {
        if (tbBaseAgr.length > 0) {
            // درج شماره ردیف برای سطرها
            // شماره ردیف در صفحه بندی کاربرد دارد
            for (let i = 0; i < tbBaseAgr.length; i++) {
                tbBaseAgr[i].RowID = i + 1;
            }
        }
        state.TbBaseAgreementData = tbBaseAgr;
    },
    // نگهداری لیست شرح سندها
    setTbBaseDocDescsData(state, tbBaseDocDesc) {
        state.TbBaseDocDescsData = tbBaseDocDesc;
    },
    // نگهداری لیست کلیه سطوح دسترسی موجود در نرم افزار
    setTbObjects(state, TbObjects) {
        state.TbObjects = TbObjects;
    },
    // نگهداری لیست سطوح دسترسی کاربر لاگین کرده
    setTbUserObjects(state, UserObjects) {
        state.TbUserObjects = UserObjects;
    },
    // نگهداری لیست شرح حساب ها - شرح ردیف ها
    setTbBaseAccDescData(state, tbBaseAccDesc) {
        state.TbBaseAccDescData = tbBaseAccDesc;
    },
    // نگهداری لیست سازمان ها
    setTbBaseOrgData(state, tbBaseOrgData) {
        state.TbBaseOrgData = tbBaseOrgData;
    },
    // نگهداری تنظیمات نرم افزار
    setSettingWebApp(state, settingWebApp) {
        state.SettingWebApp = settingWebApp;
    },
    // نگهداری لیست انواع سند
    setTbBaseDocTypeData(state, tbBaseDocTypeData) {
        state.TbBaseDocTypeData = tbBaseDocTypeData;
    },
    // نگهداری مقدار کنترل کننده شنونده کلید میانبرها
    setcanAddListenerHotKey(state, canAdd) {
        state.canAddListenerHotKey = canAdd;
    },
    // نگهداری لیست بانک ها
    setTbBaseBankData(state, tbBaseBankData) {
        state.TbBaseBankData = tbBaseBankData;
    }
}

const actions = {
    // درج شماره ردیف برای لیست دریافتی
    setRowIDForList(context, listData) {
        // آیا لیست دریافتی دارای سطر است ؟
        if (listData.length > 0) {
            // درج شماره ردیف برای سطرها
            // شماره ردیف در صفحه بندی کاربرد دارد
            for (let i = 0; i < listData.length; i++) {
                listData[i].RowID = i + 1;
            }
        }
        return listData;
    },
    // کنترل سطح دسترسی کاربر
    // آیا کاربر به این نام فرم دسترسی دارد ؟
    checkAccessUser({ state }, FormName) {
        // جستجوی نام فرم در لیست کل دسترسی ها
        let indexObjects = state.TbObjects.findIndex(function (item) {
            return item.WebFormName == FormName
        });
        if (indexObjects != -1) {
            let FormID = state.TbObjects[indexObjects].NObjectId;
            // آیا سطح دسترسی مورد نظر در لیست دسترسی های کاربر وجود دارد ؟
            let index = state.TbUserObjects.findIndex(function (item) {
                return item.NObjectId == FormID
            });
            if (index != -1) {
                // دسترسی مورد تایید است
                return true;
            } else {
                // دسترسی مورد تایید نیست
                return false
            }
        } else {
            // نام فرم معتبر نیست
            // دسترسی مورد تایید نیست
            return false;
        }
    },
    // کنترل نوع سند : آیا اجازه ذخیره دارد؟
    checkDocTypeBeSaved({ commit, dispatch, state }, docType) {
        let index = state.ListDocNotBeSaved.findIndex(itme => itme.NDocType == docType)
        if (index != -1) {
            // نوع سند در لیست انواع غیر مجازها موجود است لذا مجاز به ذخیره نمی باشد
            return { Check: false, SDocType: state.ListDocNotBeSaved[index].SDocType };
        } else {
            // نوع سند در لیست انواع غیر مجازها موجود نیست لذا مجاز به ذخیره می باشد
            return { Check: true, SDocType: '' };
        }
    },

    // عدم احراز هویت
    errorHandler({ commit, dispatch, state }, error) {
        console.log('errorHandler ...', error);
        if (error.status == 401) {
            // عدم احراز هویت
            dispatch('notify', { notText: (error.body.text != '' ? error.body.text : 'حساب کاربری شما احراز هویت نشد . لطفا مجدد لاگین نمایید .'), timeOut: 4000 });
            newRoutes.push("Login");
        } else {
            // آیا برای خطا از سمت سرور توضیحی برگشته است؟
            if (error.body.text != '') {
                // نمایش متن خطای برگشت داده شده از سمت سرور
                dispatch('notify', { notText: error.body.text, timeOut: 4000 });
            } else {
                // نمایش متن خطای عمومی
                dispatch('notify', { notText: 'در مرحله اتصال به سرور خطایی رخ داده است !' + (error.status != 0 ? '\n' + error.status + ' ' + error.statusText : ''), timeOut: 4000 });
            }
        }
    },

    // نمایش پیام هشدار بالای فرم اصلی با دکمه متوجه شدم
    alertAdmin(context, { alertText, alertDetail, alertID, color = 'ffeb3b' }) {
        if ($('#divAlertAdmin').length == 0) {
            $("<div id='divAlertAdmin' class='alertAdminPanel' style='background: #" + color + " !important'></div>").appendTo("body");
        }
        let strShow = "<div id='alertAdmin_" + alertID + "' class='alertAdmin'>";
        strShow += "<div>";
        strShow += "<p class='h6 text-info'>" + alertText + "</p>";
        strShow += "<p>" + alertDetail + "</p>";
        strShow += "</div>";
        strShow += "<div>";
        strShow += "<a onclick='AllowAlertAdmin(" + alertID + ")'>";
        strShow += "<i class='far fa-check-circle ml-2'></i>متوجه شدم</a>";
        strShow += "</div></div></div>"
        let n = $(strShow).appendTo("#divAlertAdmin");
        console.log('child ...', $("#divAlertAdmin").children().length);
    },

    // نمایش پیام موقت بالای فرم اصلی
    notify(context, { notText, timeOut, color = 'ffeb3b' }) {
        setTimeout(function () {
            let child = $('#divnotify');
            child.remove();
            let n = $("<div id='divnotify' class='notify' style='background: #" + color + " !important;'>" + notText + "</div>").appendTo("body");
            setTimeout(function () { n.remove(); }, timeOut);
        }, 250);
    },

    // نمایش پیام موقت پایین فرم اصلی
    statusApplication(context, { notText, timeOut, color = '343a40' }) {
        setTimeout(function () {
            let child = $('#divStatusApplication');
            child.remove();
            let n = $("<div id='divStatusApplication' class='statusApplication' style='background: #" + color + " !important;'><i class='fas fa-cog fa-spin fa-1x-half'></i> " + notText + "</div>").appendTo("body");
            setTimeout(function () { n.remove(); }, timeOut);
        }, 50);
    },

    // نمایش پیام لطفا صبر نمایید وسط صفحه
    pleaseWait(context, { notText, color = '343a40', stop = false }) {
        setTimeout(function () {
            if (stop == true) {
                setTimeout(() => {
                    let child = $('#divPleaseWait');
                    child.remove();
                }, 1000);
            } else {
                let n = $("<div id='divPleaseWait' class='pleaseWaitMain'><div class='pleaseWait' style='background: #" + color + " !important'><i class='fas fa-cog fa-spin fa-2x'></i><span style='margin: 10px 0;'>" + notText + "</span><span>لطفا چند لحظه صبر نمایید ...</span></div></div>").appendTo("body");
            }
        }, 50);
    },

    // ایجاد یک شماره سند جدید منحصر به فرد
    createNewNDouNum({ commit, dispatch, state }) {
        let newNDocNum = 0;
        state.TabList.forEach(function (tab) {
            if (tab.TabContent === "AccDoc") {
                if (newNDocNum < tab.NDocNu) {
                    newNDocNum = tab.NDocNu;
                }
            }
        });
        return newNDocNum + 1;
    },

    // بازیابی لیست گزارش ترازنامه از سرور
    async getSelectBalanceFromServer(context, { SpSelectBalanceSendValues, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/getSelectBalance', SpSelectBalanceSendValues)
            .then(response => {
                if (response.body.result === 'OK') {
                    context.commit('setSelectBalance', response.body.result_value);
                } else {
                    context.commit('setSelectBalance', {});
                }
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                context.dispatch('errorHandler', error);
            });
    },

    // دانلود لیست گزارش ترازنامه از سرور
    async downloadSelectBalanceFromServer(context, { DownloadType, SpSelectBalanceSendValues, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        // Vue.http.responseType = 'blob';
        await Vue.http.post('Reports/Download_SpSelectBalance_Report?DownloadType=' + DownloadType, SpSelectBalanceSendValues,
            { responseType: 'blob' })
            .then(response => {
                console.log('response ...', response);
                if (DownloadType == 'excel' && response.data != '') {
                    const url = URL.createObjectURL(new Blob([response.data], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'گزارش دفاتر ' + SpSelectBalanceSendValues.YearAcitve + '.xls')
                    document.body.appendChild(link)
                    link.click()
                } else if (DownloadType == 'pdf' && response.data != '') {
                    const url = URL.createObjectURL(new Blob([response.data], {
                        type: 'application/pdf'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'گزارش دفاتر ' + SpSelectBalanceSendValues.YearAcitve + '.pdf')
                    document.body.appendChild(link)
                    link.click()
                }
            }, error => {
                // خطای بازگشتی از وب سرویس توسط BadRequest
                console.log('// BadRequest ... ', error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                context.dispatch('errorHandler', error);
            }).catch(error => {
                // بروز خطا در اتصال به سرور
                console.log('// error ...', error);
            });
    },

    // بازیابی لیست سال های دارای اطلاعات از سرور
    async getListYearDataFromServer(context, { token }) {
        // console.log('// getListYearDataFromServer لیست سال ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getListYearData').then(response => {
            // console.log(response);
            if (response.body.result === 'OK') {
                context.commit('setListYearData', response.body.result_value);
            } else {
                context.commit('setListYearData', []);
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // بازیابی لیست کاربران از سرور
    async getListTbUsersInfoFromServer(context, { token }) {
        // console.log('// getListTbUsersInfoFromServer لیست کاربران //');
        context.commit('setListTbUsersInfo', []);
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/ListTbUsersInfo').then(response => {
            // console.log(response);
            if (response.body.result === 'OK') {
                context.commit('setListTbUsersInfo', response.body.result_value);
                // console.log(response.body.result_value);
                //newRoutes.push("AdminPanel");
            } else {
                context.commit('setListTbUsersInfo', []);
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // بازیابی هشدارهای مدیر از سرور
    async getTbAlertAdminData(context, { token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbAlertAdminData').then(response => {
            // console.log(response);
            if (response.body.result === "OK") {
                let value = response.body.result_value;
                // console.log(value);
                value.forEach(function (item) {
                    // console.log('item ...', item);
                    context.dispatch('alertAdmin', {
                        alertText: item.AlertName,
                        alertDetail: item.AlertDetail,
                        alertID: item.ID
                    })
                })
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // تایید متوجه شدم برای هشدار مدیر در سرور
    async setAllowAlertAdmin(context, { alertID }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + context.getters.getUserData.token;
        await Vue.http.get('AccountingDoc/SetAllowAlertAdmin?alertID=' + alertID).then(response => {
            // console.log(response);
            if (response.body.result === "OK") {
                // حذف هشدار مدیر از لیست در حال نمایش
                if ($('#alertAdmin_' + alertID).length != 0) $('#alertAdmin_' + alertID).remove();
                // اگر کادر والد هشدارهای خالی بود حذف شود
                if ($('#divAlertAdmin').children().length == 0) $('#divAlertAdmin').remove();
            } else {
                context.dispatch('notify', { notText: response.body.text, timeOut: 3500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // بازیابی تنظیمات نرم افزار از سرور
    async getTbSettingWebAppDataFromServer(context, { token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbSettingWebAppData').then(response => {
            // console.log(response);
            if (response.body.result === "OK") {
                context.commit('setSettingWebApp', response.body.result_value);
            } else {
                // بروز خطا در بازیابی تنظیمات - مقداردهی با مقادیر پیش فرض
                context.commit('setSettingWebApp', { BlockIPTime: 5, LogOutDashboardTime: 15, TryLoginCount: 3, TimeShowLogOutDialogue: 30, PasswordSecurityLevel: 3 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // ذخیره تنظیمات در سرور
    async EditTbSettingWebAppToServer({ commit, dispatch, state, getters }, { SettingWebApp, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/EditTbSettingWebApp', SettingWebApp)
            .then(response => {
                if (response.body.result === "OK") {
                    commit('setSettingWebApp', response.body.result_value);
                } else {
                    // بروز خطا در بازیابی تنظیمات - مقداردهی با مقادیر پیش فرض
                    commit('setSettingWebApp', { BlockIPTime: 5, LogOutDashboardTime: 15, TryLoginCount: 3, TimeShowLogOutDialogue: 30, PasswordSecurityLevel: 3 });
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // بازیابی لیست اسناد از سرور
    async getListTbDocInfoFromServer(context, { yearID, token }) {
        // console.log('// getListTbDocInfoFromServer لیست اسناد //');
        context.commit('setListTbDocInfo', []);
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/ListTbDocInfo?NYear=' + yearID).then(response => {
            if (response.body.result === 'OK') {
                // درج شماره ردیف برای سطرها
                // شماره ردیف در صفحه بندی کاربرد دارد
                let tempList = context.dispatch('setRowIDForList', response.body.result_value);
                context.commit('setListTbDocInfo', tempList);
            } else {
                context.commit('setListTbDocInfo', []);
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // مرتب سازی لیست اسناد توسط رویه (پروسیجر) سمت سرور
    async CallDocOrderToServer({ commit, dispatch, state }, { yearActive, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/CallDocOrderFromProceture?YearActive=' + yearActive).then(response => {
            // console.log(response);
            if (response.body.result === 'OK') {
                if (response.body.result_value == 1) {
                    // مرتب سازی با موفقیت اجرای شده است
                    // بازیابی مجدد لیست اسناد
                    dispatch("getListTbDocInfoFromServer", { yearID: yearActive, token: token });
                } else {
                    // مرتب سازی موفق نبوده است
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                }

            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            context.dispatch('errorHandler', error);
        });
    },

    // تغییر وضعیت اسناد توسط رویه (پروسیجر) سمت سرور
    async ChangeDocStatusToServer({ commit, dispatch, state }, { ChangeDocData, token }) {
        // console.log(ChangeDocData);
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        let ActionResult;
        await Vue.http.post('AccountingDoc/ChangeDocStatusFromProceture', ChangeDocData)
            .then(response => {
                // console.log(response);
                if (response.body.result === 'OK') {
                    // دریافت مجدد لیست اسناد از سرور

                    // اعلام نتیجه به کامپاننت
                    if (response.body.result_value.length > 0) {
                        ActionResult = "OK";
                    } else {
                        ActionResult = "NoCount";
                    }
                } else {
                    // dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                    ActionResult = response.body.text;
                }
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                context.dispatch('errorHandler', error);
                ActionResult = "Error";
            });
        return ActionResult;
    },

    // فیلتر لیست اسناد توسط رویه (پروسیجر) سمت سرور
    async FilterListDocToServer({ commit, dispatch, state }, { filterData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        let listResult;
        await Vue.http.post('AccountingDoc/FilterListDocFromProceture', filterData)
            .then(response => {
                // console.log('filter ...', response);
                if (response.body.result === 'OK') {
                    listResult = response.body.result_value;
                    // درج شماره ردیف برای نتیجه دریافتی
                    // شماره ردیف در صفحه بندی کاربرد دارد
                    for (let i = 0; i < listResult.length; i++) {
                        listResult[i].RowID = i + 1;
                    }
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                }
            }, error => {
                console.log('error ...', error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                context.dispatch('errorHandler', error);
            });
        return listResult;
    },

    // تغییر وضعیت سند به دائمی در سرور
    async changeDocStatusInServer({ commit, dispatch, state, getters }, { NId }) {
        let changeRespons = false;
        let token = getters.getUserData.token;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/changeDocStatus?NId=' + NId)
            .then(response => {
                if (response.body.result === "OK") {
                    // تغییر وضعیت سند محلی به دائمی
                    commit('changeDocStatusInLocall', { NId });
                    changeRespons = true;
                } else {
                    changeRespons = false;
                }
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return changeRespons;
    },

    // بازیابی سند با کد سند و شناسه سند
    async GetTbDocInfoByNIdNDocNuFromServer({ commit, dispatch, state }, { NId, NDocNu, NYear, token }) {
        let docData = [];
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbDocInfoByNIdNDocNu?NId=' + NId + '&NDocNu=' + NDocNu + '&NYear=' + NYear)
            .then(response => {
                docData = response.body.result_value;
                if (docData.NDocNu == 0) {
                    // if (response.body.result === "Empty") {
                    docData.NDocNu = NDocNu;
                    docData.NId = NId;
                    // عدم مشاهده مقدار برای کد درج شده
                    // dispatch('notify', { notText: 'برای کد ' + (NDocNu != 0 ? NDocNu : NId) + ' سندی مشاهده نشد .', timeOut: 2500 });
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                }
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });

        return docData;
    },

    // بازیابی لیست حساب ها - رکوردهای کل اسناد
    async GetTbDocInfoAllRecordFromServer({ commit, dispatch, state }, { NYear, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbDocInfoAllRecord?NYear=' + NYear)
            .then(response => {
                if (response.body.result === "OK") {
                    // ذخیره لیست تمام رکوردهای تمام سندها در متغییر محلی
                    commit('setTbDocInfoAllRecord', response.body.result_value);
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 3500 });
                }
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // بازیابی اطلاعات محلی موجود در مرورگر
    async getAccDocDataFromLocalData({ commit, dispatch, state }) {
        // بررسی وجود اطلاعات در ذخیره محلی
        if (localStorage.length > 0) {

            // حرکت به تعداد رکوردهای ذخیره محلی
            for (let i = 0; i < localStorage.length; i++) {
                // استخراج کلید رکورد ذخیره محلی
                let key = localStorage.key(i);
                // آیا این رکورد مربوط به سامانه مالی پرش است؟
                if (key.toString().split('_')[0] === "Paresh") {
                    // بازیابی اطلاعات محلی
                    let tbAccDocLocalData = JSON.parse(localStorage.getItem(key));
                    // ایجاد یک تب جدید و تغذیه با اطلاعات محلی
                    let tabData = {
                        tabContent: 'AccDoc',
                        NId: tbAccDocLocalData.NId,
                        NDocNu: tbAccDocLocalData.NDocNu,
                        tabID: 0,
                        CheckChangeData: true,
                        LocalData: true,
                        TabAccDocData: tbAccDocLocalData
                    };
                    commit('addTabList', tabData);
                }
            }
            if (state.TabList.length > 0) {
                setTimeout(() => {
                    // ارسال شماره آخرین تب به رویداد تغییر تب فعال
                    BusEvent.$emit('ChangeTabActive', state.TabList[state.TabList.length - 1].TabID);
                }, 200);
            }
        } else {
            // هیچ اطلاعات محلی مشاهده نشد
        }
    },

    // دریافت تاریخ شمسی جاری از سرور
    async getPersianDateFromServer(context) {
        // console.log('// getPersianDateFromServer تاریخ جاری //');
        await Vue.http.get('Public/PersianDate').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                context.commit('setPersianDateValue', response.body.result_value);
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست آی پی های مسدود شده از سرور
    async getBlockIpListFromServer({ commit, dispatch, state }, { token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/getBlockIpListFromServer').then(response => {
            if (response.body.result === "OK") {
                commit('setListBlockIP', response.body.result_value);
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // ذخیره آی پی مسدود شده در سرور
    async AddNewBlockIPToServer({ commit, dispatch, state, getters }, { NewBlockIPData, token }) {
        // متغییر بازگشت مقادیر
        let check = false;

        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/AddNewBlockIP', NewBlockIPData)
            .then(response => {
                if (response.body.result === "OK") {
                    // اعمال سطر جدید در مخزن محلی
                    // unshift درج در ابتدای آرایه
                    // push درج در انتهای آرایه
                    state.ListBlockIP.unshift(response.body.result_value);
                    // commit('setListBlockIP', response.body.result_value);
                    check = true;
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 3500 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return check;
    },

    // ویرایش آی پی مسدود شده در سرور
    async EditBlockIPToServer({ commit, dispatch, state, getters }, { EditBlockIPData, token }) {
        // متغییر بازگشت مقادیر
        let check = false;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/EditBlockIP', EditBlockIPData)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در مخزن محلی
                    let index = state.ListBlockIP.findIndex(itme => itme.ID == EditBlockIPData.ID)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.ListBlockIP[index].UserIP = EditBlockIPData.UserIP
                        state.ListBlockIP[index].BlockIPTime = EditBlockIPData.BlockIPTime
                        state.ListBlockIP[index].BlockIPTimeForShow = response.body.result_value
                    } else {
                        dispatch('notify', { notText: "در بروزرسانی اطلاعات محلی خطایی رخ داده است .\nصفحه را بروزرسانی کرده و مجدد تلاش نمایید .", timeOut: 3500 });
                    }
                    check = true;
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 4500 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return check;
    },

    // حذف آی پی مسدود شده از سرور
    async DeleteBlockIPToServer({ commit, dispatch, state, getters }, { DeleteBlockIPData, token }) {
        // متغییر بازگشت مقادیر
        let check = false;

        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeleteBlockIP', DeleteBlockIPData)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در مخزن محلی
                    let index = state.ListBlockIP.findIndex(itme => itme.ID == DeleteBlockIPData.ID)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.ListBlockIP[index].ActiveStatus = false
                        dispatch("notify", {
                            notText: "آی پی (" + DeleteBlockIPData.UserIP + ") با موفقیت حذف گردید .",
                            timeOut: 2500,
                        });
                        check = true;
                    } else {
                        dispatch('notify', { notText: "در بروزرسانی اطلاعات محلی خطایی رخ داده است .\nصفحه را بروزرسانی کرده و مجدد تلاش نمایید .", timeOut: 3500 });
                    }
                    // commit('setListBlockIP', response.body.result_value);
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 3500 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return check;
    },

    // دریافت لیست فعالیت کاربران از سرور
    async getTbActivityListDataFromSever({ commit, dispatch, state }, { token }) {
        let activityList = null;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbActivityListData').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                // commit('setTbPersonData', response.body.result_value);
                activityList = response.body.result_value;
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
        return activityList;
    },

    // دریافت لیست طرف حساب ها از سرور
    async getTbPersonDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbPersonDataFromSever لیست طرف حساب ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbPersonList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbPersonData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // ذخیره شخصیت در سرور
    async SaveNewPersonToServer({ commit, dispatch, state, getters }, { PersonData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        let check = false;
        await Vue.http.post('AccountingDoc/SaveNewPerson', PersonData)
            .then(response => {
                if (response.body.result === "OK") {
                    check = true;
                    // دریافت کد شخصیت جدید از سرور و درج در مخزن محلی
                    PersonData.NPerID = response.body.result_value.NPerID;
                    // اعمال سطر جدید در مخزن محلی
                    // unshift درج در ابتدای آرایه
                    // push درج در انتهای آرایه
                    state.TbPersonData.unshift(PersonData);
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return check;
    },

    // ویرایش اطلاعات شخصیت در سرور
    async EditPersonDataToServer({ commit, dispatch, state, getters }, { PersonData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        let check = false;
        await Vue.http.post('AccountingDoc/EditPersonData', PersonData)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در اطلاعات شخصیت در مخزن محلی
                    let index = state.TbPersonData.findIndex(itme => itme.NPerID == PersonData.NPerID)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.TbPersonData[index] = PersonData;
                        check = true;
                    } else {
                        dispatch('notify', { notText: "در بروزرسانی اطلاعات محلی خطایی رخ داده است .\nصفحه را بروزرسانی کرده و مجدد تلاش نمایید .", timeOut: 2500 });
                    }
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 4000 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
        return check;
    },

    // حذف اطلاعات شخصیت در سرور
    async DeletePersonDataFromServer({ commit, dispatch, state }, { NPerID, token }) {
        let check = false;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeletePersonData?NPerID=' + NPerID).then(response => {
            if (response.body.result === "OK") {
                // حذف اطلاعات شخصیت از متغییر محلی شخصیت ها
                state.TbPersonData = state.TbPersonData.filter(function (t) {
                    return t.NPerID != NPerID;
                });
                // اعلام حذف موفق
                check = true;
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 4000 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            check = false;
        });
        return check;
    },

    // دریافت لیست طبقه بندی عملیاتی از سرور
    async getTabagheBandiAmaliyatiFromSever({ commit, dispatch, state }, { NYear, token }) {
        // console.log('// GetTabagheBandiAmaliyatiFromSever لیست طبقه بندی عملیاتی //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTabagheBandiAmaliyatiList?NYear=' + NYear).then(response => {
            if (response.body.result === "OK") {
                console.log(response);
                commit('setListTabagheBandiAmaliyati', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // ListTabagheBandiAmaliyati
    // ذخیره طبقه بندی عملیاتی جدید در سرور
    async SaveNewTabagheBandiAmaliyatiToServer({ commit, dispatch, state, getters }, { TabagheBandiAmaliyatiData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/SaveNewTabagheBandiAmaliyati', TabagheBandiAmaliyatiData)
            .then(response => {
                if (response.body.result === "OK") {
                    // اعمال سطر جدید در مخزن محلی
                    // unshift درج در ابتدای آرایه
                    // push درج در انتهای آرایه
                    state.ListTabagheBandiAmaliyati.push(response.body.result_value);
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ویرایش اطلاعات طبقه بندی عملیاتی در سرور
    async EditTabagheBandiAmaliyatiToServer({ commit, dispatch, state, getters }, { TabagheBandiAmaliyatiData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/EditTabagheBandiAmaliyati', TabagheBandiAmaliyatiData)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در اطلاعات طبقه بندی عملیاتی در مخزن محلی
                    let index = state.ListTabagheBandiAmaliyati.findIndex(itme => itme.NPerID == TabagheBandiAmaliyatiData.NPerID)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.ListTabagheBandiAmaliyati[index].NPerLastName = TabagheBandiAmaliyatiData.NPerLastName
                    } else {
                        dispatch('notify', { notText: "در بروزرسانی اطلاعات محلی خطایی رخ داده است .\nصفحه را بروزرسانی کرده و مجدد تلاش نمایید .", timeOut: 2500 });
                    }
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // حذف اطلاعات طبقه بندی در سرور
    async DeleteTabagheBandiAmaliyatiToServer({ commit, dispatch, state, getters }, { DeleteTabagheBandiData, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeleteTabagheBandiAmaliyati', DeleteTabagheBandiData)
            .then(response => {
                if (response.body.result === "OK") {
                    // حذف اطلاعات سرفصل حساب از متغییر محلی سرفصل حساب ها
                    state.ListTabagheBandiAmaliyati = state.ListTabagheBandiAmaliyati.filter(function (t) {
                        return t.NPerID != DeleteTabagheBandiData.NPerID;
                    });
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ذخیره مرکز هزینه در سرور
    async SaveNewBaseUsePlaceToServer({ commit, dispatch, state, getters }, { BaseUsePalce, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/SaveNewBaseUsePlace', BaseUsePalce)
            .then(response => {
                if (response.body.result === "OK") {
                    // اعمال سطر جدید در مخزن محلی
                    // unshift درج در ابتدای آرایه
                    // push درج در انتهای آرایه
                    state.TbBaseUsePlaceData.unshift(BaseUsePalce);
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ویرایش مرکز هزینه در سرور
    async EditBaseUsePlaceToServer({ commit, dispatch, state, getters }, { BaseUsePalce, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/EditBaseUsePlace', BaseUsePalce)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در اطلاعات مرکز هزینه در مخزن محلی
                    let index = state.TbBaseUsePlaceData.findIndex(itme => itme.NCode == BaseUsePalce.NCode)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.TbBaseUsePlaceData[index].NCode = BaseUsePalce.NCode;
                        state.TbBaseUsePlaceData[index].SDesc = BaseUsePalce.SDesc;
                    } else {
                        dispatch('notify', { notText: "در بروزرسانی اطلاعات محلی خطایی رخ داده است .\nصفحه را بروزرسانی کرده و مجدد تلاش نمایید .", timeOut: 2500 });
                    }
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ذخیره سرفصل حساب جدید در سرور
    async SaveNewBaseAccToServer({ commit, dispatch, state, getters }, { NewTbBaseAcc, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/SaveNewBaseAcc', NewTbBaseAcc)
            .then(response => {
                if (response.body.result === "OK") {
                    // دریافت وضعیت آخرین سطح از سرور و درج در متغییر محلی
                    NewTbBaseAcc.NUseState = response.body.result_value.NUseState;
                    // اعمال سطر جدید در مخزن محلی
                    // unshift درج در ابتدای آرایه
                    // push درج در انتهای آرایه
                    state.AllTbBaseAccData.push(NewTbBaseAcc);
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ویرایش اطلاعات سرفصل حساب در سرور
    async EditBaseAccDataToServer({ commit, dispatch, state, getters }, { EditBaseAcc, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/EditBaseAccData', EditBaseAcc)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در اطلاعات شخصیت در مخزن محلی
                    let index = state.AllTbBaseAccData.findIndex(itme => itme.NCode == EditBaseAcc.NCode)
                    if (index != -1) {
                        // ذخیره تغییرات در مخزن محلی
                        state.AllTbBaseAccData[index].SDesc = EditBaseAcc.SDesc;
                    } else {
                        // alert('Not Find Save');
                    }
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // حذف اطلاعات سرفصل حساب در سرور
    async DeleteBaseAccDataToServer({ commit, dispatch, state, getters }, { DeleteBaseAcc, token }) {
        // این چند خط شاید خطای حذف سرفصل در سرور را برطرف کند
        // Vue.http.headers.common['Content-Type'] = 'application/json';
        // Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
        // Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*';
        // Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Methods, Access-Control-Allow-Origin';
        // Vue.http.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS, DELETE';

        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeleteBaseAccData', DeleteBaseAcc)
            .then(response => {
                if (response.body.result === "OK") {
                    // حذف اطلاعات سرفصل حساب از متغییر محلی سرفصل حساب ها
                    state.AllTbBaseAccData = state.AllTbBaseAccData.filter(function (t) {
                        return t.NCode != DeleteBaseAcc.NCode;
                    });
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // حذف رقم بودجه از سرفصل حساب در سرور
    async DeleteBaseAccBudgetToServer({ commit, dispatch, state, getters }, { DeleteBaseAcc, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeleteBaseAccBudget', DeleteBaseAcc)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در بودجه سرفصل حساب و والدینش در مخزن محلی
                    response.body.result_value.forEach(function (item) {
                        // لیست بازگشتی از سرور حاوی :
                        // سطر جاری و فرزندانش که رقم بودجه آنها صفر شده  است
                        // والدین سطر جاری که رقم بودجه آنها اصلاح شده است
                        let index = state.AllTbBaseAccData.findIndex(itme => itme.NCode == item.NCode)
                        if (index != -1) {
                            // ذخیره تغییرات در مخزن محلی
                            state.AllTbBaseAccData[index].NBudgetCode = item.NBudgetCode;
                            state.AllTbBaseAccData[index].NBudget = item.NBudget;
                        } else {
                            alert('Not Find Save');
                        }
                    })
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 3500 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ثبت بودجه برای سرفصل حساب در سرور
    async EditBaseAccBudgetDataToServer({ commit, dispatch, state, getters }, { EditBudget, token }) {
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        console.log(EditBudget);
        await Vue.http.post('AccountingDoc/EditBaseAccBudgetData', EditBudget)
            .then(response => {
                if (response.body.result === "OK") {
                    //  اعمال تغییرات در بودجه سرفصل حساب و والدینش در مخزن محلی
                    response.body.result_value.forEach(function (item) {
                        let index = state.AllTbBaseAccData.findIndex(itme => itme.NCode == item.NCode)
                        if (index != -1) {
                            // ذخیره تغییرات در مخزن محلی
                            state.AllTbBaseAccData[index].NBudgetCode = item.NBudgetCode;
                            state.AllTbBaseAccData[index].NBudget = item.NBudget;
                        } else {
                            alert('Not Find Save');
                        }
                    });
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                } else {
                    dispatch('notify', { notText: response.body.text, timeOut: 3500 });
                }
            }, error => {
                console.log('// error ... //');
                console.log(error);
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
            });
    },

    // ذخیره اطلاعات سند در سرور
    async SaveTbDocInfo({ commit, dispatch, state, getters }, { AccDocData, token }) {
        if (AccDocData.CheckChangeData == true) {
            // متغییر بازگشت مقادیر
            let check = { Status: false, NId: 0, NDocNu: 0 };

            Vue.http.headers.common['Authorization'] = 'bearer ' + token;
            await Vue.http.post('AccountingDoc/SaveTbDocInfo', AccDocData)
                .then(async response => {
                    if (response.body.result === "OK") {
                        check = {
                            Status: true,
                            NId: response.body.result_value.NId,
                            NDocNu: response.body.result_value.NDocNu
                        };
                        // ذخیره آخرین نوع سند و آخرین سازمان استفاده
                        // جهت استفاده در ایجاد سند جدید
                        commit('setLastNDocTypeCode', AccDocData.NDocType);
                        commit('setLastNOrgCode', AccDocData.NOrgCode);
                        // دریافت مجدد لیست اسناد
                        // جهت بازسازی لیست تب اسناد
                        await dispatch('getListTbDocInfoFromServer', {
                            yearID: getters.getPersianDateValue.PersianYear,
                            token: token
                        });
                        // دریافت مجدد لیست شرح اسناد
                        await dispatch('getTbBaseDocDescsDataFromSever', { token: token });
                        // دریافت مجدد لیست شرح ردیف های سند
                        await dispatch('getTbBaseAccDescDataFromSever', { token: token });
                    }
                    dispatch('notify', { notText: response.body.text, timeOut: 2500 });
                }, error => {
                    console.log('// error ... //');
                    console.log(error);
                    // فراخوانی تابع مدیریت خطای اتصال به سرور
                    dispatch('errorHandler', error);
                    check = { Status: false, NId: 0, NDocNu: 0 };
                });
            return check;
        } else {
            dispatch('notify', { notText: 'برای ( سند شماره ' + AccDocData.NDocNu + ' ) تغییراتی مشاهده نشد .', timeOut: 2500 });
            return { Status: false, NId: 0, NDocNu: 0 };
        }
    },

    // حذف سند از لیست اسناد
    async deleteDocInfoFromServer({ commit, dispatch, state, getters }, { AccDocID, token }) {
        let check = false;
        if (AccDocID.NId != 0) {
            // این چند خط شاید خطای حذف سند در سرور را برطرف کند
            // Vue.http.headers.common['Content-Type'] = 'application/json';
            // Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
            // Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*';
            // Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Methods, Access-Control-Allow-Origin';
            // Vue.http.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS, DELETE';


            Vue.http.headers.common['Authorization'] = 'bearer ' + token;
            await Vue.http.post('AccountingDoc/DeleteTbDocInfo?NId=' + AccDocID.NId + '&NDocNu=' + AccDocID.NDocNu)
            .then(async response => {
                if (response.body.result === "OK") {
                    try {
                        // حذف اطلاعات سند از متغییر محلی لیست اسناد
                        // استفاده از state خطا می دهد
                        // استفاده از getters , commit درست است
                        let listTemp = await getters.getListTbDocInfo;
                        listTemp = listTemp.filter(function (t) {
                            return t.NId != AccDocID.NId;
                        });
                        commit('setListTbDocInfo', listTemp);
                    } catch (error) {
                        console.log('error Filter ...', error);
                    }
                    // اعلام حذف موفق
                    check = true;
                }
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }, error => {
                // فراخوانی تابع مدیریت خطای اتصال به سرور
                dispatch('errorHandler', error);
                check = false;
            });
        } else {
            // اطلاعات سند هنوز در سرور ذخیره نشده است
            check = true;
        }
        return check;
    },

    // حذف یک تب از لیست تب ها
    deleteTabFromTabList({ commit, dispatch, state }, { tabID }) {
        state.TabList = state.TabList.filter(function (t) {
            return t.TabID != tabID;
        });
        return true;
    },

    // دریافت لیست حساب ها از سرور
    async getTbBaseAccDataFromSever({ commit, dispatch, state }, { yearID, token }) {
        // console.log('// getTbBaseAccDataFromSever لیست حساب ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbBaseAcc?year=' + yearID).then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseAccData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست کل حساب ها از سرور جهت فرم مدیریت کدینگ
    async getAllTbBaseAccDataFromSever({ commit, dispatch, state }, { yearID, token }) {
        // console.log('// getAllTbBaseAccDataFromSever لیست کل حساب ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetAllTbBaseAcc?year=' + yearID).then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setAllTbBaseAccData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست مراکز هزینه از سرور
    async getTbBaseUsePlaceDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseUsePlaceDataFromSever لیست مراکز هزینه//');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbBaseUsePlaceList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseUsePlaceData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // حذف مرکز هزینه از سرور با کد مرکز
    async DeleteBaseUsePlaceFromServer({ commit, dispatch, state }, { NCode, token }) {
        let check = false;
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.post('AccountingDoc/DeleteBaseUsePlace?NCode=' + NCode).then(response => {
            if (response.body.result === "OK") {
                // حذف مرکز هزینه از لیست محلی
                commit('DeleteBaseUsePlaceToLocalList', { NCode: NCode });
                // اعلام حذف موفق
                check = true;
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 4000 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
            check = false;
        });
        return check;
    },

    // دریافت لیست قراردادها از سرور
    async getTbBaseAgreementDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseAgreementDataFromSever لیست قراردادها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/GetTbBaseAgreementList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseAgreementData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست شرح سندها از سرور
    async getTbBaseDocDescsDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseDocDescsDataFromSever لیست شرح سند ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbBaseDocDescsList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseDocDescsData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست کلیه سطوح دسترسی موجود در نرم افزار از سرور
    async getTbObjectsFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbObjectsFromSever لیست کلیه سطوح دسترسی //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbObjects').then(response => {
            if (response.body.result === "OK") {
                // console.log('TbObjects ...', response.body.result_value);
                commit('setTbObjects', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست شرح حساب ها (شرح دریف ها) از سرور
    async getTbBaseAccDescDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseAccDescDataFromSever لیست شرح حساب ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbBaseAccDescList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseAccDescData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست سازمان ها از سرور
    async getTbBaseOrgDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseOrgDataFromSever لیست سازمان ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbBaseOrgDataList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseOrgData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست بانک ها از سرور
    async getTbBaseBankDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseBankDataFromSever لیست بانک ها //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbBaseBankDataList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseBankData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

    // دریافت لیست انواع سند از سرور
    async getTbBaseDocTypeDataFromSever({ commit, dispatch, state }, { token }) {
        // console.log('// getTbBaseDocTypeDataFromSever لیست انواع سند //');
        Vue.http.headers.common['Authorization'] = 'bearer ' + token;
        await Vue.http.get('AccountingDoc/getTbBaseDocTypeDataList').then(response => {
            if (response.body.result === "OK") {
                // console.log(response);
                commit('setTbBaseDocTypeData', response.body.result_value);
            } else {
                dispatch('notify', { notText: response.body.text, timeOut: 2500 });
            }
        }, error => {
            // فراخوانی تابع مدیریت خطای اتصال به سرور
            dispatch('errorHandler', error);
        });
    },

}


export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/Store/Modules/AdminPanel.js